import { Layout } from '@eneco/flows/components';
import { createFlowProvider } from '@eneco/flows/utils';

import { routes, actions, initialContext } from './DecarbonisationLeadFlow.config';
import { DecarbonisationLeadFlowContext } from './types';

const { Provider, Navigation, Router } = createFlowProvider<DecarbonisationLeadFlowContext>({
  routes,
  actions,
  initialContext,
});

const DecarbonisationLeadFlow = () => {
  return (
    <Provider>
      <Layout>
        <Layout.Header>
          <Navigation componentName="DecarbonizationLeadFlowNavigation" />
        </Layout.Header>
        <Router />
      </Layout>
    </Provider>
  );
};

export default DecarbonisationLeadFlow;
